
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accommodation",
      function () {
        return require("private-next-pages/accommodation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accommodation"])
      });
    }
  